module.exports = __webpack_public_path__ + "static/img/fxn-login-bg.ec217d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fxn-login-bg.png
// module id = ZQV/
// module chunks = 124